<template>
  <div>
    <DynamicComponent edc-id="polaris-bill-reconciliation" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'BillReconciliation',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
